if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form
                    .querySelector("[name=id]")
                    ?.removeAttribute?.("disabled");
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );

                // gift card product - recipient form
                this.recipientForm = this.querySelector("recipient-form");
            }

            getSubmitButton() {
                var formId = this.form.getAttribute("id");

                return (
                    this.querySelector('[type="submit"]') ||
                    document.querySelector('[form="' + formId + '"]')
                );
            }

            getMessageWrapper() {
                this.messageWrapper =
                    this.messageWrapper ||
                    this.querySelector(".message-wrapper");

                if (this.messageWrapper) {
                    return this.messageWrapper;
                }

                this.messageWrapper = createFromTemplate("message-wrapper");
                this.getSubmitButton()?.after(this.messageWrapper);

                return this.messageWrapper;
            }

            onSubmitHandler(evt) {
                const cart = document.querySelector("cart-sidebar");

                if (!cart) {
                    return;
                }

                evt.preventDefault();
                const submitButton = this.getSubmitButton();
                if (submitButton.classList.contains("loading")) return;

                this.handleErrorMessage();

                if (!submitButton.querySelector(".loading-overlay"))
                    submitButton.prepend(
                        createFromTemplate("template-loading-overlay")
                    );

                submitButton.setAttribute("aria-disabled", true);
                submitButton.classList.add("loading");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                const formData = new FormData(this.form);
                cart.setActiveElement &&
                    cart.setActiveElement(document.activeElement);
                formData.append(
                    "sections",
                    cart.getSectionsToRender().map((section) => section.id)
                );

                formData.append("sections_url", window.location.pathname);
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);
                            return;
                        }

                        if (cart && response.sections) {
                            cart && cart.renderContents(response);
                        } else {
                            // sometime Shopify doesn't return requested sections
                            // in such case reload page
                            window.location.reload();
                        }
                        // cartSidebar && cartSidebar.triggerCartSidebarOnSubmit(response);

                        // hide gift card recipient form on submit
                        if (this.recipientForm)
                            this.hideRecipientForm(this.recipientForm);
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        submitButton.classList.remove("loading");
                        submitButton.removeAttribute("aria-disabled");
                    });
            }

            hideRecipientForm(recipientForm) {
                const input = recipientForm.querySelector("input");
                const fields = recipientForm.querySelector(".recipient-fields");

                if (input.checked) {
                    let animation = fields.animate(
                        { height: [fields.clientHeight + "px", "0"] },
                        { duration: 300, easing: "linear" }
                    );

                    input.checked = false;
                    animation.onfinish = () => {
                        fields.style.height = "0";
                    };
                }
            }

            handleErrorMessage(errorMessage = false) {
                const messageWrapper = this.getMessageWrapper();

                // gift-card recipient form error messages
                if (
                    errorMessage.email ||
                    errorMessage.send_on ||
                    errorMessage.message
                )
                    errorMessage =
                        errorMessage.email ||
                        errorMessage.send_on ||
                        errorMessage.message;

                this.errorMessage =
                    this.errorMessage ||
                    messageWrapper.querySelector(".error-message");
                this.errorMessage.textContent = errorMessage || "";
                if (errorMessage) messageWrapper.removeAttribute("hidden");
                else messageWrapper.setAttribute("hidden", true);
            }
        }
    );
}



/* ケースオプションとギャラリーの連動。

   オプションアプリが描画したラジオを読み、選ばれたケースに対応するスライドへスライダーを送る。
   飛び先は回転動画でも静止画でもよい。
   対応表は商品メタフィールド:
     custom.case_option_image_indices      … LED 非搭載時（1始まりのカンマ区切り）
     custom.case_option_image_indices_led  … LED 搭載時
   番号はギャラリーに並んだ順で数える。テーマが出さないメディアは数に入れない。

   アプリごとにマークアップが違うため、次の順で「ケース」「LED」のグループを見つける。
     1. fieldset + legend の見出し文字（Lift 形式）
     2. .case-sector 内のラジオと value の文字（旧 Globo 形式）
   選択肢のラベルは value ではなく表示テキストから読む。value が UUID のアプリがあるため。 */
document.addEventListener("DOMContentLoaded", function () {
    const targetNode = document.getElementById('product-option');
    if (!targetNode) return;

    const config = { childList: true, subtree: true };

    /* 手入力の項目なので区切りは数字以外なら何でも受け付ける。
       ピリオドや読点で入力されても並び順として読めるようにする。 */
    function parseIndices(attrValue) {
        if (!attrValue) return null;
        const parsed = (attrValue.match(/-?\d+/g) || [])
            .map(s => parseInt(s, 10) - 1)
            .filter(n => Number.isInteger(n) && n >= 0);
        return parsed.length > 0 ? parsed : null;
    }

    // ラジオの表示テキスト。アプリによって入る場所が違うので順に探す
    function labelOf(radio) {
        const label = radio.closest('label');
        const el = label && (
            label.querySelector('.lift-value-label') ||
            label.querySelector('.lift-card-name') ||
            label
        );
        const text = el ? el.textContent : '';
        return (text || radio.value || '').replace(/\s+/g, '');
    }

    function groupTitle(radio) {
        const set = radio.closest('fieldset');
        const legend = set && set.querySelector('legend');
        return legend ? legend.textContent.replace(/[\s*]/g, '') : '';
    }

    // name 属性でまとめる。表示順は DOM 順を保つ
    function groupsIn(root) {
        const radios = root.querySelectorAll('input[type="radio"]');
        const map = new Map();
        radios.forEach(r => {
            if (!map.has(r.name)) map.set(r.name, []);
            map.get(r.name).push(r);
        });
        return [...map.values()];
    }

    function pickGroups() {
        const scope = document.querySelector('.case-sector') ? document.querySelector('.case-sector').parentElement : targetNode;
        const groups = groupsIn(scope || targetNode);
        if (groups.length === 0) return null;

        let caseGroup = null;
        let ledGroup = null;

        groups.forEach(group => {
            const title = groupTitle(group[0]);
            const labels = group.map(labelOf);
            const isLed = title.includes('LED') || labels.every(t => t.includes('LED'));
            const isCase = title.includes('ケース') || title.toUpperCase().includes('CASE');
            if (isLed && !ledGroup) ledGroup = group;
            else if (isCase && !caseGroup) caseGroup = group;
        });

        // 見出しから判定できないときは、旧実装と同じく LED 以外の最初のグループをケースとみなす
        if (!caseGroup) {
            caseGroup = groups.find(g => g !== ledGroup) || null;
        }
        return caseGroup ? { caseGroup, ledGroup } : null;
    }

    /* 対応表の番号は、ギャラリーに並んだスライドの通し位置を指す。
       ケースごとの回転動画へ飛ばすため、動画スライドも数に入れる。 */
    function gallerySlides() {
        const gallery = document.querySelector('.product__info-block');
        if (!gallery) return [];
        return Array.from(gallery.querySelectorAll('.slider__slide'));
    }

    function bind() {
        const picked = pickGroups();
        const slides = gallerySlides();
        if (!picked || slides.length === 0) return false;

        const caseRadios = picked.caseGroup;
        const ledRadios = picked.ledGroup;

        const gallery = document.querySelector('.product__info-block');
        const sliderEl = gallery.querySelector('.slider.slider--desktop') || gallery.querySelector('.slider');
        const baseMap = parseIndices(sliderEl ? sliderEl.dataset.caseOptionIndices : null);
        const ledMap = parseIndices(sliderEl ? sliderEl.dataset.caseOptionIndicesLed : null);

        function activeMapping() {
            if (!ledRadios) return baseMap;
            const on = ledRadios.some(r => r.checked && !labelOf(r).includes('非'));
            return (on && ledMap) ? ledMap : baseMap;
        }

        function scrollToCase(caseIdx) {
            if (caseIdx < 0) return;
            const mapping = activeMapping();
            const slideIdx = (mapping && mapping[caseIdx] !== undefined) ? mapping[caseIdx] : caseIdx;
            const slide = slides[slideIdx];
            if (!slide) return;
            const current = document.querySelector('.slider__slide.slide-active');
            if (current) current.classList.remove('slide-active');
            slide.classList.add('slide-active');
            const slider = document.querySelector('.slider.slider--desktop') || document.querySelector('.slider');
            if (slider) slider.scrollTo({ top: 0, left: slide.offsetLeft, behavior: 'smooth' });
        }

        caseRadios.forEach((radio, index) => {
            if (radio.dataset.mdlCaseBound === '1') return;
            radio.dataset.mdlCaseBound = '1';
            radio.addEventListener('change', function (event) {
                if (!event.isTrusted || !this.checked) return;
                scrollToCase(index);
            });
        });

        if (ledRadios) {
            ledRadios.forEach(radio => {
                if (radio.dataset.mdlLedBound === '1') return;
                radio.dataset.mdlLedBound = '1';
                radio.addEventListener('change', function (event) {
                    if (!event.isTrusted || !this.checked) return;
                    scrollToCase(caseRadios.findIndex(r => r.checked));
                });
            });
        }
        return true;
    }

    // オプションは非同期で描画され、再描画されることもあるので監視は切らない
    const observer = new MutationObserver(function () { bind(); });
    observer.observe(targetNode, config);
    bind();
});
